import { useCommonFormsTranslation } from '@libs/utils/translations'
import RestTypes, {
  RestTypesType,
  REST_TYPE_IDS,
  REST_ACCIDENT_ID
} from '@spa/constants/RestTypes'
import * as yup from 'yup'

import { halfDay } from '../RestFormSection/components/DayFields/DayFields'

const hoursRegexp = /[0-2][0-9]:[0-5][0-9]/

export const useRestFormValidations = () => {
  const { t } = useCommonFormsTranslation()

  return yup.object().shape({
    time_range: yup.array().when('rest_type', {
      is: restType => {
        return RestTypes.get(restType.value).type === RestTypesType.HOUR
      },
      then: yup
        .array()
        .of(
          yup
            .string()
            .matches(hoursRegexp, t('commonForms.errors.hoursDigitFormat'))
            .required()
        )
        .unique(t('commonForms.errors.notEqual'))
    }),

    rest_type: yup.object().shape({
      value: yup.mixed().oneOf(REST_TYPE_IDS)
    }),

    dateRange: yup.object().when('rest_type', {
      is: restType => RestTypes.get(restType.value).type === RestTypesType.DAY,
      then: yup.object().shape({
        start: yup
          .object()
          .shape({
            date: yup.date().required(),
            halfDay: yup.mixed().oneOf([...halfDay])
          })
          .required(),
        end: yup
          .object()
          .shape({
            date: yup.date().required(),
            halfDay: yup.mixed().oneOf([...halfDay])
          })
          .required()
      }),
      otherwise: yup.object().nullable()
    }),
    accident_date: yup
      .string()
      .test(
        'accident_date_before_start_date',
        t('commonForms.forms.rest.accidentTooLate'),
        function test() {
          const {
            accident_date,
            dateRange: { start },
            rest_type: { value }
          } = (this as any).from[0].value
          if (value === REST_ACCIDENT_ID) {
            return Boolean(accident_date) && start.date >= accident_date
          }
          // Always true for every other rest type
          return true
        }
      )
  })
}
